export default class FooterAccordion {
    /**
     * Class constructor
     *
     * @arg {object} - `el` Footer Accordion item
    */
    constructor(el) {
        if(!el) {
            return;
        }
        this.el = el;

        this.init()
    }

    init() {
        this.createListeners()   
    }

    createListeners() {
        this.el.addEventListener("click", () => {
            this.el.classList.toggle('is-active');
            this.el.nextSibling.classList.toggle('is-active');
        })
    }

  
}

const footerAccordions = document.querySelectorAll('.js-footer-accordion');

footerAccordions.forEach(element => {
    new FooterAccordion(element)
});